import { HistoricoSwapModel } from './historico-swap.model';
import { SocioModel } from './socio.model';

export type StatusHabilitacao =
  | 'INI'
  | 'PEN'
  | 'ENV'
  | 'REJ'
  | 'APR';

export const STATUS_LABELS: Record<StatusHabilitacao, string> = {
  INI: 'Iniciado',
  PEN: 'Pendente',
  ENV: 'Submetido / Aguardando SWAP',
  REJ: 'Ajustes Solicitados',
  APR: 'Aprovado / Liberado',
};

export const STATUS_COLORS: Record<StatusHabilitacao, string> = {
  INI: '#9E9E9E',
  PEN: '#9E9E9E',
  ENV: '#2196F3',
  REJ: '#F44336',
  APR: '#4CAF50',
};

export class HabilitacaoSwapModel {
  constructor(
    public readonly id: number | null,
    public empresa: any | null,
    public status: StatusHabilitacao,
    public dataLiberacao: string | null,
    public socios: SocioModel[],
    public historicos: HistoricoSwapModel[],
    public ultimaAtualizacao: string | null,
    public mensagemSwap: string | null,
  ) {}

  static fromJson(json: any): HabilitacaoSwapModel {
    console.log(json);
    const status = json.status || json.statusHabilitacao || 'INI';
    return new HabilitacaoSwapModel(
      json.id ?? null,
      json.empresa || null,
      status as StatusHabilitacao,      
      json.dataLiberacao || null,
      (json.socios || []).map((s: any) => SocioModel.fromJson(s)),
      (json.historicos || json.historico || json.Historicos || []).map((h: any) => HistoricoSwapModel.fromJson(h)),
      json.ultimaAtualizacao || null,
      json.mensagemSwap || json.mensagem || null,
    );
  }

  get isReadOnly(): boolean {
    return this.status === 'APR' || this.status === 'ENV';
  }

  get isEditable(): boolean {
    return (
      this.status === 'INI' ||
      this.status === 'PEN' ||
      this.status === 'REJ'
    );
  }

  get statusLabel(): string {
    return STATUS_LABELS[this.status] || this.status;
  }

  get statusColor(): string {
    return STATUS_COLORS[this.status] || '#9E9E9E';
  }

  get dataLiberacaoFormatada(): string {
    if (!this.dataLiberacao) return '';
    try {
      const date = new Date(this.dataLiberacao);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return this.dataLiberacao;
    }
  }
}
